module.exports = __webpack_public_path__ + "static/media/cover-tablet-738x57@2x.8fceb855.webp";